import { action } from 'satcheljs';
import type { UserActionType } from '../store/schema/UserAction';
import type RequestState from '../store/schema/RequestState';

/**
 * Action to set the user's action type on voting page in the store.
 */
export const setUserActionType = action('setUserActionType', (userActionType: UserActionType) => ({
    userActionType,
}));

/**
 * Action to set the user's action state on voting page in the store.
 */
export const setUserActionState = action('setUserActionState', (userActionState: RequestState) => ({
    userActionState,
}));

/**
 * Action to set the button id that user just action on so that we could set focus back to the button when Dialog being dismissed.
 */
export const setUserActionButtonId = action(
    'setUserActionButtonId',
    (userActionButtonId: string) => ({
        userActionButtonId,
    })
);
